import request from '@/axios'

// 员工登录
export function login(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff/login',
    method: 'post',
    data
  })
}
